export default __webpack_public_path__ + "static/media/card3.7c6cd055.jpg";